var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C13.2503 17 16.7265 13.6854 16.9846 9.50009C17.0016 9.22447 16.7761 9 16.5 9H9.5C9.22386 9 9 8.77614 9 8.5V1.5C9 1.22386 8.77553 0.998377 8.49991 1.01538C4.31459 1.27352 1 4.74968 1 9C1 13.4183 4.58172 17 9 17Z",
    stroke: "#1F1F22",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9803 6.7223C16.7388 3.68453 14.3155 1.26129 11.2778 1.01979C11.0025 0.997907 10.7778 1.22386 10.7778 1.5V6.72222C10.7778 6.99836 11.0017 7.22222 11.2778 7.22222H16.5001C16.7762 7.22222 17.0021 6.99758 16.9803 6.7223Z",
    stroke: "#1F1F22",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.4255befc81fb69cfded3e20c47d343e1.svg";
export { ForwardRef as ReactComponent };